import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [dark, setDark] = useState(true);

  return (
    <div
      className={`${
        dark ? "bg-gray-900 text-white" : "bg-gray-100 text-black"
      } border-b px-8 py-4 flex justify-between items-center`}
    >
      <h1
        onClick={() => navigate("/")}
        className="text-2xl font-bold text-blue-500 cursor-pointer"
      >
        CodemintX
      </h1>

      <div className="flex items-center gap-4">
        <button
          onClick={() => setDark(!dark)}
          className="px-4 py-2 rounded-lg border"
        >
          {dark ? "🌙 Dark" : "☀️ Light"}
        </button>

        {!user ? (
          <>
            <button
              onClick={() => navigate("/login")}
              className="px-5 py-2 rounded-lg border"
            >
              Login
            </button>
            <button
              onClick={() => navigate("/signup")}
              className="bg-blue-600 hover:bg-blue-700 px-5 py-2 rounded-lg text-white"
            >
              Sign Up
            </button>
          </>
        ) : (
          <>
            <span className="text-sm text-gray-400">
              👋 {user.name}
            </span>
            <button
              onClick={() => {
                logout();
                navigate("/");
              }}
              className="bg-red-600 hover:bg-red-700 px-5 py-2 rounded-lg text-white"
            >
              Logout
            </button>
          </>
        )}
      </div>
    </div>
  );
}
